module.exports = __webpack_public_path__ + "static/about-section-bg-84e6b5aaa40f2215549032ef4327f515.jpg";